import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";

const OfficerReportNarrative = ({ report = {} }) => {
  return (
    <Form
      layout="vertical"
      initialValues={{ narrative: report.narrative || "" }}
    >
      <StyledGridRow gutter={16} justify={'start'}>
        <StyledGridCol xs={24}>
          <FormItem label="Narrative" name="narrative">
            <TextField rows="8" inputType="textarea" />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
};

export default OfficerReportNarrative;
